import React from 'react';

const CustomerTable = ({ customers, heading, type }) => {
  return (
    <div className="customer-table-container">
      <style>{`
        /* ── Container ── */
        .customer-table-container {
          max-width: 1280px;
          margin: 2rem auto;
          padding: 0 1rem;
          font-family: 'Segoe UI', 'Arial', sans-serif;
        }

        /* ── Heading ── */
        .table-heading {
          text-align: center;
          font-size: 1.8rem;
          font-weight: 700;
          letter-spacing: 0.5px;
          margin-bottom: 1.5rem;
          padding-bottom: 0.5rem;
          border-bottom: 3px solid;
          display: inline-block;
          padding: 0 2rem 0.5rem 2rem;
          border-radius: 0 0 12px 12px;
        }
        .heading-red {
          color: #c62828;
          border-bottom-color: #c62828;
          background: rgba(198, 40, 40, 0.06);
        }
        .heading-green {
          color: #1b5e20;
          border-bottom-color: #1b5e20;
          background: rgba(27, 94, 32, 0.06);
        }

        /* ── Table Wrapper ── */
        .table-wrapper {
          border-radius: 16px;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.10);
          background: #ffffff;
          padding: 2px;
          /* Fixed height with vertical scroll */
          height: 500px;
          overflow-y: auto;
          overflow-x: auto;
        }

        /* ── Table ── */
        .customer-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 1rem;
          min-width: 600px;
          background: white;
          border-radius: 16px;
          overflow: hidden;
        }

        /* ── Sticky Header ── */
        .customer-table thead {
          position: sticky;
          top: 0;
          z-index: 10;
        }
        .customer-table thead tr {
          background: #f8f9fc;
        }
        .customer-table th {
          padding: 1rem 0.75rem;
          font-weight: 700;
          font-size: 0.95rem;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          border-bottom: 3px solid #e0e4ea;
          text-align: center;
          white-space: nowrap;
          background: #f8f9fc;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
        }
        .th-red {
          color: #c62828;
          border-bottom-color: #c62828;
        }
        .th-green {
          color: #1b5e20;
          border-bottom-color: #1b5e20;
        }

        /* ── Body ── */
        .customer-table tbody tr {
          transition: background 0.15s ease;
        }
        .customer-table tbody tr:nth-child(even) {
          background: #fafbfc;
        }
        .customer-table tbody tr:hover {
          background: #eef2f7;
        }
        .customer-table td {
          padding: 0.9rem 0.75rem;
          text-align: center;
          border-bottom: 1px solid #eef1f5;
          vertical-align: middle;
          font-size: 0.98rem;
        }

        /* ── Status badges ── */
        .badge {
          display: inline-block;
          padding: 0.25rem 0.75rem;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.85rem;
          background: #f0f0f0;
          color: #333;
        }
        .badge-red {
          background: #ffebee;
          color: #b71c1c;
        }
        .badge-green {
          background: #e8f5e9;
          color: #1b5e20;
        }
        .badge-gold {
          background: #fff8e1;
          color: #bf7c00;
        }

        /* ── Numeric / monetary values ── */
        .num {
          font-weight: 600;
          font-family: 'Courier New', monospace;
        }
        .num-red {
          color: #c62828;
        }
        .num-green {
          color: #1b5e20;
        }

        .sub-text {
          font-size: 0.8rem;
          color: #777;
          margin-left: 4px;
          font-weight: 400;
        }

        /* ── Index column ── */
        .idx {
          font-weight: 700;
          color: #888;
          font-size: 0.9rem;
        }

        /* ── Scrollbar Styling ── */
        .table-wrapper::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }
        .table-wrapper::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 8px;
        }
        .table-wrapper::-webkit-scrollbar-thumb {
          background: #c1c7cd;
          border-radius: 8px;
        }
        .table-wrapper::-webkit-scrollbar-thumb:hover {
          background: #a0a7ae;
        }

        /* ── Responsive ── */
        @media (max-width: 768px) {
          .customer-table-container {
            margin: 1rem auto;
            padding: 0 0.5rem;
          }
          .table-heading {
            font-size: 1.4rem;
            padding: 0 1rem 0.3rem 1rem;
          }
          .table-wrapper {
            height: 400px;
          }
          .customer-table {
            font-size: 0.85rem;
            min-width: 500px;
          }
          .customer-table th,
          .customer-table td {
            padding: 0.6rem 0.4rem;
          }
          .badge {
            font-size: 0.7rem;
            padding: 0.15rem 0.5rem;
          }
          .sub-text {
            font-size: 0.7rem;
          }
        }

        @media (max-width: 480px) {
          .table-heading {
            font-size: 1.2rem;
          }
          .table-wrapper {
            height: 350px;
          }
          .customer-table {
            font-size: 0.75rem;
            min-width: 400px;
          }
          .customer-table th,
          .customer-table td {
            padding: 0.4rem 0.25rem;
          }
        }
      `}</style>

      <center>
        <h2
          className={`table-heading ${
            type === 1 ? 'heading-red' : 'heading-green'
          }`}
        >
          {heading}
        </h2>
      </center>

      <div className="table-wrapper">
        <table className="customer-table">
          <thead>
            <tr>
              <th className={type === 1 ? 'th-red' : 'th-green'}>نمبر</th>
              <th className={type === 1 ? 'th-red' : 'th-green'}>گاہک کا نام</th>
              <th className={type === 1 ? 'th-red' : 'th-green'}>فون نمبر</th>
              {type === 1 ? (
                <th className="th-red">آرڈر نہیں دیا</th>
              ) : (
                <th className="th-green">آخری وصولی کی تاریخ</th>
              )}
              {type === 1 ? (
                <th className="th-red">آخری آرڈر کی تاریخ</th>
              ) : (
                <th className="th-green">اختتامی بیلنس</th>
              )}
            </tr>
          </thead>
          <tbody>
            {customers.map((customer, index) => (
              <tr key={customer.id || index}>
                <td className="idx">{index + 1}</td>
                <td>
                  <strong>{customer.name}</strong>
                </td>
                <td>{customer.phone}</td>

                {type === 1 ? (
                  <td>
                    <span className="badge badge-red">
                      {customer.days_inactive}{' '}
                      <span className="sub-text">دن</span>
                    </span>
                  </td>
                ) : (
                  <td>
                    <span className="badge badge-gold">
                      {customer.last_payment_date}
                      <span className="sub-text">
                        &nbsp;(دن {customer.days_since_last_payment})
                      </span>
                    </span>
                  </td>
                )}

                {type === 1 ? (
                  <td>
                    <span className="badge badge-gold">
                      {customer.last_order_date}
                    </span>
                  </td>
                ) : (
                  <td>
                    <span
                      className={`num ${
                        type === 1 ? 'num-red' : 'num-green'
                      }`}
                    >
                      {customer.outstanding_balance}
                    </span>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomerTable;